import {
  createCodeableConcept,
  getCodes,
  type WithId,
} from '@quromedical/fhir-common';
import { first } from '@quromedical/utils';

import { type Appointment, AppointmentSchema } from './schema';

export const mapModelToFhirAppointment = (
  appointment: Appointment,
): fhir4.Appointment => {
  const { status, appointmentType, date, description, subject } = appointment;

  const type = createCodeableConcept(
    appointmentType,
    appointmentType,
    appointmentType,
  );

  return {
    resourceType: 'Appointment',
    participant: [
      {
        actor: subject,
        status: 'accepted',
      },
    ],
    appointmentType: type,
    start: date,
    end: date,
    description,
    status,
  };
};

export const mapFhirAppointmentToModel = (
  fhir: WithId<fhir4.Appointment>,
): Appointment => {
  const { status, start, description, participant, appointmentType } = fhir;

  const mapped = {
    date: start,
    description: description,
    status,
    subject: first(participant)?.actor,
    appointmentType: first(getCodes(appointmentType)),
  };

  const parsed = AppointmentSchema.safeParse(mapped);

  if (parsed.success == false) {
    throw parsed.error;
  }

  return parsed.data;
};
